import { PropsWithChildren } from 'react';

import BaseBox from '../box/box';
import { styled } from '../styles/styles';

type EmptyBodyProps = PropsWithChildren;

const Box = styled(BaseBox)`
  border-bottom: 1px solid ${(props) => props.theme.colors.alpha.black[10]};
`;

const EmptyBody = ({ children }: EmptyBodyProps) => {
  return (
    <Box p={4} textAlign="center">
      {children}
    </Box>
  );
};

export default EmptyBody;
